import React, { Component, useState } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { AlmacenForm } from "./components/AlmacenForm";
import { getCategoriaAcopio } from "../../../../../../utility/utils";

class GestionAlmacen extends Component {
    state = {
        almacenInventarioId: null,
        almacenInventarioNombre: null,
    };

    componentWillMount() {
        this.setState({ almacenInventarioId: this.props.match.params.id });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    setAlmacenInventarioNombre = (nombre) => {
        this.setState({ almacenInventarioNombre: nombre });
    };

    render() {
        let  tituloVista = "Sobrante de almacén";
        if (this.state.almacenInventarioNombre) {
            tituloVista += `: ${this.state.almacenInventarioNombre}`;
        }

        const categoriaAcopio = getCategoriaAcopio(this.props.user);

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="inventario_activo"
                    titulo={tituloVista}
                    subtitulo=""
                    col="12"
                >
                    <AlmacenForm
                        almacenInventarioId={this.state.almacenInventarioId}
                        regresar={this.regresar}
                        setAlmacenInventarioNombre={this.setAlmacenInventarioNombre}
                        categoriaAcopio={categoriaAcopio}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(GestionAlmacen);
